/* Built In Imports */

/* External Imports */
import {
  Box,
  Flex,
  FormControl,
  Grid,
  Link,
  ListItem,
  SimpleGrid,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import parser from 'html-react-parser';
import forEach from 'lodash/forEach';

/* Internal Imports */
import MidContainer from '@Layout/MidContainer';
import SingleImage from '@components/Card/SingleImage';
import SectionTitle from '@components/Headings/SectionTitle';
import StructuredTextContent from '@components/UI/StructuredTextContent';
import { refineUrlDomain } from '@components/Utility/utils';

/* Services */

const GeneralSeating = ({ section, region, lang, csrData }) => {
// console.log(section);
let hideNote = '';
let countryCode = '';
let prgUrl = '';
let seatAvailability = [];
const sectionContent = section?.sectionContent;
let priceList = sectionContent[12]?.data;
if (csrData) {
  countryCode = csrData?.result[0]?.queried_country_code;
  prgUrl = csrData?.result[0]?.url_registration;
  forEach(csrData?.result[0]?.tickets, function (data) {
    const el = { data };
    seatAvailability.push(el);
  });
  hideNote = priceList?.find(el => el.country == countryCode);
}
if (hideNote == undefined) {
  hideNote = priceList?.find(el => el.country == 'GB');
}

const cardStyle = {
  Open: {
    outline: '2px solid #979797',
    boxShadow: 'none',
    // background: '#FFFFFF',
  },
  Selected: {
    outline: '2px solid #CF4520',
    background: '#F5F0E5',
  },
  Full: {
    outline: 'none',
    boxShadow: 'none',
    background: '#494949',
    opacity: '0.7',
  },
};

const cardInfo = (cardObj, bulletstyle) => {
  return (
    <>
      {cardObj?.data?.map((data, i) => {
        return data.Category === 'Donor'
          ? cardDetail(data, i, bulletstyle, priceList, 'Donor')
          : cardDetail(data, i, bulletstyle, priceList, 'General');
      })}
    </>
  );
};

const cardDetail = (data, indx, bulletstyle, priceList, Category) => {
  let priceData = priceList?.find(el => el.country == countryCode);
  if (priceData == undefined) {
    priceData = priceList?.find(el => el.country == 'GB');
  }
  const seatAvailable = seatAvailability?.find(el => el.data.name == data.RefName);
  const seatStatus = data?.Status;
  return (
    <>
      <Box
        className={indx}
        w="280px"
        minH="280px"
        borderRadius="10px"
        _focus={{
          outline: '0',
        }}
        display="grid"
        placeContent="center"
        _hover={{
          outline: '2px solid #CF4520 !Important',
          background: '#F5F0E5 !Important',
        }}
        outline="0"
        fontFamily={'FedraSansStd-medium'}
        position="relative"
        style={
          seatAvailable?.data.seats_available < 1
            ? cardStyle.Full
            : cardStyle.Open
        }
      >
        {/* Full popup */}
        {seatAvailable?.data.seats_available < 1 || seatStatus === 'Full' && (
          <Box
            bgColor="#494949"
            position="absolute"
            borderRadius={{ base: '3.7px', md: '8px' }}
            border={{
              base: 'solid 1.14px transparent',
              md: 'solid 1.14px transparent',
            }}
            w="100%"
            h="100%"
            zIndex="2"
            fontFamily={'FedraSansStd-medium'}
            fontSize={{ base: '20px', md: '20px' }}
            color="#ffffff"
            display="flex"
            alignItems="center"
            justifyContent="center"
            opacity="0.5"
          >
            <Text color="#ffffff" opacity="1">
              FULL
            </Text>
          </Box>
        )}
        <Box marginX={{ base: '0px', md: '0px' }} textAlign="center">
          <Text fontSize={{ base: '22px', md: '22px' }} color="#000000">
            {data.Name}
          </Text>
        </Box>
        <Box className="price-box" fontFamily="FedraSansStd-book">
          {csrData && (
            <Box
              margin="4px auto"
              fontSize={{ base: '22px', md: '22px' }}
              fontWeight="600"
              p="0"
              color="#CF4520"
              textAlign="center"
            >
              {/* {Category == 'General' && (
                <Box
                  className="strike-price"
                  textDecoration="line-through"
                  color="#A5A096"
                  fontWeight="500"
                  as="span"
                  pr="14px"
                >
                  {priceData?.currency}{' '}
                  {(indx == 0 && priceData?.Section1) ||
                    (indx == 1 && priceData?.Section2) ||
                    (indx == 2 && priceData?.Section3)}
                </Box>
              )} */}
              {priceData?.currency}{' '}
              {(indx == 0 && Category == 'Donor' && priceData?.DonorA) ||
                (indx == 1 && Category == 'Donor' && priceData?.DonorB) ||
                // (indx == 0 &&
                //   Category == 'General' &&
                //   priceData?.Section1EB) ||
                // (indx == 1 &&
                //   Category == 'General' &&
                //   priceData?.Section2EB) ||
                // (indx == 2 && Category == 'General' && priceData?.Section3EB)}
                (indx == 0 && priceData?.Section1) ||
                (indx == 1 && priceData?.Section2) ||
                (indx == 2 && priceData?.Section3) ||
                (indx == 3 && priceData?.Section4) ||
                (indx == 4 && priceData?.Section5) ||
                (indx == 5 && priceData?.Section6)}
            </Box>
          )}
          {csrData == undefined && (
           <Box
           margin="4px auto"
           fontSize={{ base: '22px', md: '22px' }}
           fontWeight="600"
           p="0"
           color="#CF4520"
           textAlign="center"
         >
           {Category == 'General' && (
             <Box
               className="strike-price"
               textDecoration="line-through"
               color="#A5A096"
               fontWeight="500"
               as="span"
               pr="14px"
             >
               {/* {priceData?.Section5 && priceData?.currency}{' '} */}
               {(indx == 0 && priceData?.Section1 != '' &&  priceData?.currency + ' ' + priceData?.Section1) ||
                 (indx == 1 && priceData?.Section2 != '' &&  priceData?.currency + ' ' + priceData?.Section2) ||
                 (indx == 2 && priceData?.Section3 != '' &&  priceData?.currency + ' ' + priceData?.Section3) ||
                 (indx == 3 && priceData?.Section4 != '' &&  priceData?.currency + ' ' + priceData?.Section4) ||
                 (indx == 4 && priceData?.Section5 != '' &&  priceData?.currency + ' ' + priceData?.Section5) ||
                 (indx == 5 && priceData?.Section6 != '' &&  priceData?.currency + ' ' + priceData?.Section6)}
             </Box>
           )}
           {!isNaN(priceData?.DonorA) ? priceData?.currency : '' || !isNaN(priceData?.DonorA) ? priceData?.currency : ''}{' '}
           {(indx == 0 && Category == 'Donor' && priceData?.DonorA) ||
             (indx == 1 && Category == 'Donor' && priceData?.DonorB) ||
             (indx == 0 && priceData?.Section1EB) ||
             (indx == 1 && priceData?.Section2EB) ||
             (indx == 2 && priceData?.Section3EB) ||
             (indx == 3 && priceData?.Section4EB) ||
             (indx == 4 && priceData?.Section5EB) ||
             (indx == 5 && priceData?.Section6EB)}
         </Box>
          )}

          {csrData &&
            priceData.country == 'GB' &&
            data?.Category === 'Donor' && (
              <Box
                margin="2px 16px 0"
                fontSize="16px"
                fontWeight="600"
                p="0px 16px"
                color="#28231E"
                textAlign="center"
                mb="0px"
                minH="24px"
              >
                <Box
                  color="#000000"
                  fontWeight="500"
                  as="span"
                  pr="4px"
                  fontSize="14px"
                >
                  {sectionContent[13]?.text}
                </Box>
                {data?.TaxDeduction}
              </Box>
            )}
          <Box
            borderTop="1px solid #9B8E71"
            m="25px 0 0 0"
            p="10px 0 5px 0"
            w="232px"
          ></Box>
          <Box
            pb={data.Category == 'General' ? '20px' : '0'}
            textAlign="center"
          >
            <Text
              className="description"
              fontSize="14px"
              fontFamily="FedraSansStd-book"
              p="5px 0"
              lineHeight="18px"
              // w={bulletstyle === 'withbullet' ? '90%' : '90%'}
            >
              {bulletstyle === 'withbullet' && (
                <UnorderedList textAlign="left" display="inline-block">
                  {data.Descripton.value_1 != '' && (
                    <ListItem mb="5px">
                      {parser(data.Descripton.value_1 || '')}
                    </ListItem>
                  )}
                  {data.Descripton.value_2 != '' && (
                    <ListItem mb="5px">
                      {parser(data.Descripton.value_2 || '')}
                    </ListItem>
                  )}
                </UnorderedList>
              )}
              {bulletstyle === '' && parser(data.Descripton.value_1 || '')}
            </Text>
          </Box>
        </Box>
        <Flex placeContent="center" w="100%" mt="10px">
          <Box d="flex" placeContent="center" m="0">
            <Link
              href={refineUrlDomain(
                data.LinkUrl,
                region,
                lang
              )}
              mb="0"
              display="block"
              fontWeight={'500'}
              fontFamily={'FedraSansStd-medium'}
              fontSize={'16px'}
              bgColor={data.LinkUrl ? '#cf4520' : 'rgb(207 69 32 / 41%)'}
              h={'auto'}
              textAlign="center"
              padding={'7px 19px'}
              borderRadius="5px"
              color="#faf7f0"
              textDecoration="none"
              width={'auto'}
              minW="127px"
              minH="43px"
              cursor={data.LinkUrl ? 'pointer' : 'not-allowed'}
              _hover={{
                bg: data.LinkUrl ? '#000054' : '',
              }}
              target={data.LinkUrl ? '_blank' : ''}
            >
              {data.CTAButton}
            </Link>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

const programCard1 = (cardObj, bulletstyle) => {
  return (
    <>
      <Box
        mt="0px"
        mb="0px"
        id="program-details"
        _focus={{
          outline: '0',
        }}
      >
        <Grid
          placeItems="center"
          placeContent="center"
          width="auto"
          mx="auto"
        >
          <FormControl>
            <SimpleGrid
              columns={{ lg: 3, md: 2, sm: 1, base: 1 }}
              gridGap="28px"
              mt="10px"
              className="gridComponent"
            >
              {cardInfo(cardObj, '')}
            </SimpleGrid>
          </FormControl>
        </Grid>
      </Box>
    </>
  );
};

const programCard2 = (cardObj, bulletstyle) => {
  return (
    <>
      <Box
        mt="20px"
        mb="20px"
        id="program-details"
        sx={{
          '.radio': {
            top: { base: '20px !important', md: '30px !important' },
            right: { base: '10px !important', md: '20px !important' },
          },
        }}
        _focus={{
          outline: '0',
        }}
      >
        <Grid
          placeItems="center"
          placeContent="center"
          width="auto"
          mx="auto"
        >
          <FormControl>
            <SimpleGrid
              columns={{ lg: cardObj?.data?.length > 1 ? 2 : 1, md: cardObj?.data?.length > 2 ? 2 : 1, sm: 1, base: 1 }}
              gridGap="28px"
              mt="10px"
              className="gridComponent"
            >
              {cardInfo(cardObj, 'withbullet')}
            </SimpleGrid>
          </FormControl>
        </Grid>
      </Box>
      {hideNote?.country == 'GB' && (
        <Box
          fontFamily="FedraSansStd-book"
          fontSize={{ base: '12px', md: '12px' }}
          color="#28231E"
          textAlign="center"
          maxW={{ base: '272px', md: '560px' }}
          m="20px auto 0 auto"
          lineHeight="19.2px"
        >
          {StructuredTextContent(section?.sectionContent[9]?.body)}
        </Box>
      )}
    </>
  );
};

return (
  <>
    <a name="program-categorycard" />
    <MidContainer id="program-categorycard">
      <SectionTitle titleObj={sectionContent[0]} />
      {sectionContent[1].image != null && (
        <SingleImage
          sectionContent={sectionContent[1]}
          region={region}
          lang={lang}
          my="30px"
          minH="168px"
        />
      )}
      {section?.sectionContent[17]?.body?.value?.document?.children[0]?.children[0]?.value != '' && (<>
        <Box fontFamily="FedraSansStd-book"
        fontSize={{ base: '14px', md: '15px' }}
        color="#28231E"
        textAlign="center"
        pb={{ base: '30px', md: '40px' }}
        >
        {StructuredTextContent(section?.sectionContent[17]?.body)}
        </Box>
      </>)}
      <Box justifyContent="center" id="seating-pricing">
        {sectionContent[2]?.titleText != '' && (<>
          <Box
            as="h2"
            pb={'15px'}
            textAlign="center"
            w="100%"
          >
            <Box
              fontFamily="FedraSansStd-medium"
              color="#28231E"
              fontSize={{ base: '20px', md: '24px' }}
            >
              {sectionContent[2]?.titleText}
            </Box>
          </Box>
        </>)}
        <Box
          fontFamily="FedraSansStd-book"
          fontSize={{ base: '15px', md: '16px' }}
          textAlign="center"
          textTransform="uppercase"
          color="#CF4520"
          pb="5px"
        >
          {StructuredTextContent(section?.sectionContent[3]?.body)}
        </Box>
        <Box
          fontFamily="FedraSansStd-book"
          fontSize={{ base: '14px', md: '15px' }}
          color="#28231E"
          textAlign="center"
          pb="20px"
        >
          {StructuredTextContent(section?.sectionContent[4]?.body)}
        </Box>
        {programCard1(sectionContent[5])}
      </Box>
      {section?.sectionContent[15]?.linkUrl != '' && (
      <Flex placeContent="center" w="100%" mt="10px">
          <Box d="flex" placeContent="center" m="10px 0 30px 0">
            <Link
             href={refineUrlDomain(
              section?.sectionContent[15]?.linkUrl,
              region,
              lang
            )}
              mb="0"
              display="block"
              fontWeight={'500'}
              fontFamily={'FedraSansStd-medium'}
              fontSize={'16px'}
              bgColor={section?.sectionContent[15]?.linkUrl ? '#cf4520' : 'rgb(207 69 32 / 41%)'}
              h={'auto'}
              textAlign="center"
              padding={'10px 22px'}
              borderRadius="5px"
              color="#faf7f0"
              textDecoration="none"
              width={'auto'}
              minW="127px"
              minH="43px"
              cursor={section?.sectionContent[15]?.linkUrl ? 'pointer' : 'not-allowed'}
              _hover={{
                bg: section?.sectionContent[15]?.linkUrl ? '#000054' : '',
              }}
              target={section?.sectionContent[15]?.linkUrl ? '_blank' : ''}
            >
              {section?.sectionContent[15]?.buttonText}
            </Link>
          </Box>
        </Flex>
      )}
      {section?.sectionContent[16] && (
        <Box fontFamily="FedraSansStd-book" fontSize='16px' bgColor='#FFF3E9' border='#C8B8AA 2px solid' borderRadius="16px" m="40px auto 0 auto" padding="9px 0" width={{base:'95%', md:'100%'}} textAlign="center">
          {StructuredTextContent(section?.sectionContent[16]?.body)}
        </Box>)}
      <Box justifyContent="center" mt="30px">
        <Box as="h2" pb="15px" pt="10px" textAlign="center" w="100%">
          <Box
            color="#28231E"
            fontFamily="FedraSansStd-medium"
            fontSize={{ base: '20px', md: '24px' }}
          >
            {sectionContent[6]?.titleText}
          </Box>
        </Box>
        <Box
          fontFamily="FedraSansStd-book"
          fontSize={{ base: '15px', md: '16px' }}
          textAlign="center"
          color="#000000"
          maxW={{ base: '90%', md: '560px' }}
          m="0px auto"
        >
          {sectionContent[7]?.text}
        </Box>
        {programCard2(sectionContent[8], 'withbullet')}
      </Box>
      <Box as="h2" pb={'0px'} textAlign="center" w="100%" mt="30px">
        <Box
          color="#28231E"
          fontFamily="FedraSansStd-medium"
          fontSize={{ base: '20px', md: '24px' }}
        >
          {sectionContent[10]?.titleText}
        </Box>
      </Box>
      <Box
        fontFamily="FedraSansStd-book"
        width={{ base: '60%', md: '550px' }}
        m="0px auto"
        p="20px 0 30px 0"
        fontSize="16px"
        className="program-info event-text"
      >
        <Box>{StructuredTextContent(section?.sectionContent[11]?.body)}</Box>
      </Box>
      <style>
        {`
        .program-info p {text-align: center; font-size:16px }
        @media (max-width: 767px) {}   
        @media only screen and (max-width: 360px) {
          .gridComponent {
              grid-template-columns: repeat(1, minmax(0, 1fr));
              margin-top: 10px;
          }
        }
        `}
      </style>
    </MidContainer>
  </>
);
};

export default GeneralSeating;